import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="338" height="31" viewBox="0 0 338 31" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M1 23.28C110.6-2.71 224.7-4.55 335.33 10.47M1.63 14.43C129.97 33.46 258.77 33.79 336 21.93" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);